import { RegisterAccountInput } from '../../../API';
import { QueryOutputType, RegisterAccountQuery } from '../../../common/type/QueryType';
import { graphqlOperationWithTokenRefresh } from '../../../common/api/graphqlOperation';

const query = /* GraphQL */ `
	query RegisterAccount($input: RegisterAccountInput!, $expiredToken: String) {
		registerAccount(input: $input, expiredToken: $expiredToken) {
			responseType
			message
			loginUserInfo {
				userName
				companyName
				permissionName
				authority
			}
		}
	}
`;

export const queryRegisterAccount = async (
	registerAccountInput: RegisterAccountInput,
	authorizationToken: string,
): Promise<QueryOutputType<RegisterAccountQuery>> => {
	const apiResponse = await graphqlOperationWithTokenRefresh<RegisterAccountQuery>(query, { input: registerAccountInput }, authorizationToken);
	console.log(apiResponse);

	return apiResponse;
};
